var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 6H8.33333C7.59733 6 7 6.59733 7 7.33333V12.6667C7 13.4027 7.59733 14 8.33333 14H13.6667C14.4027 14 15 13.4027 15 12.6667V7.33333C15 6.59733 14.4027 6 13.6667 6Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 18H8.33333C7.59733 18 7 18.5973 7 19.3333V24.6667C7 25.4027 7.59733 26 8.33333 26H13.6667C14.4027 26 15 25.4027 15 24.6667V19.3333C15 18.5973 14.4027 18 13.6667 18Z",
    fill: "#575757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 30H8.33333C7.59733 30 7 30.5973 7 31.3333V36.6667C7 37.4027 7.59733 38 8.33333 38H13.6667C14.4027 38 15 37.4027 15 36.6667V31.3333C15 30.5973 14.4027 30 13.6667 30Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 6H20.3333C19.5973 6 19 6.59733 19 7.33333V12.6667C19 13.4027 19.5973 14 20.3333 14H25.6667C26.4027 14 27 13.4027 27 12.6667V7.33333C27 6.59733 26.4027 6 25.6667 6Z",
    fill: "#575757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 18H20.3333C19.5973 18 19 18.5973 19 19.3333V24.6667C19 25.4027 19.5973 26 20.3333 26H25.6667C26.4027 26 27 25.4027 27 24.6667V19.3333C27 18.5973 26.4027 18 25.6667 18Z",
    fill: "#575757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 30H20.3333C19.5973 30 19 30.5973 19 31.3333V36.6667C19 37.4027 19.5973 38 20.3333 38H25.6667C26.4027 38 27 37.4027 27 36.6667V31.3333C27 30.5973 26.4027 30 25.6667 30Z",
    fill: "#575757"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 6H32.3333C31.5973 6 31 6.59733 31 7.33333V12.6667C31 13.4027 31.5973 14 32.3333 14H37.6667C38.4027 14 39 13.4027 39 12.6667V7.33333C39 6.59733 38.4027 6 37.6667 6Z",
    fill: "#575757"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 18H32.3333C31.5973 18 31 18.5973 31 19.3333V24.6667C31 25.4027 31.5973 26 32.3333 26H37.6667C38.4027 26 39 25.4027 39 24.6667V19.3333C39 18.5973 38.4027 18 37.6667 18Z",
    fill: "#575757"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 30H32.3333C31.5973 30 31 30.5973 31 31.3333V36.6667C31 37.4027 31.5973 38 32.3333 38H37.6667C38.4027 38 39 37.4027 39 36.6667V31.3333C39 30.5973 38.4027 30 37.6667 30Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllApp);
export default __webpack_public_path__ + "static/media/allApp.d12ab760e82874dfe2192b6ecf57c516.svg";
export { ForwardRef as ReactComponent };